import { useStore } from '@/composables/index';

export default function useEventHub() {
  const store = useStore();
  return store.$app.$eventHub;
}
